// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3diXY","list":"BalanceDue_list__1mgly","listRow":"BalanceDue_listRow__1UIMs","total":"BalanceDue_total__2FpGR"};